import React from 'react';
import {
  WizardMetaData,
  WizardPendoData,
  wizardStyles,
} from '../Wizard/Wizard';
import CharacteristicsFields from './CharacteristicsFields';
import CharacteristicsPopoversList from './CharacteristicsPopoversList';
import InterventionsFields from './InterventionsFields';
import InterventionsPopoversList from './InterventionsPopoversList';
import CharacteristicsImage from 'assets/images/WizardCharacteristics.png';
import InterventionsImage from 'assets/images/WizardInterventions.png';
import { Banner, Text } from 'components/core';
import { Stack } from 'components/layout';

const InterventionsDescription = () => {
  return (
    <>
      <InterventionsPopoversList />
      <Banner className={wizardStyles.CustomBanner}>
        <Text className={wizardStyles.A11YText}>
          {`Think about your planned analyses and add items that you intend to
          compare together (e.g. "Pain medication", "Physical therapy",
          "Placebo").`}
        </Text>
      </Banner>
    </>
  );
};

const InterventionsStudyFormDescription = () => {
  return (
    <Stack spacing={4}>
      <Text className={wizardStyles.A11YText}>
        {`1. You'll be able to select which interventions, comparisons, etc were reported in the study.`}
      </Text>
      <Text className={wizardStyles.A11YText}>
        {`2. You can also create multiple groups associated with each intervention. This is useful when
            there are multiple study groups reported or if you want to create subgroups for a subgroup analysis.`}
      </Text>
    </Stack>
  );
};

const CharacteristicDescription = () => {
  return (
    <>
      <CharacteristicsPopoversList />
      <Banner className={wizardStyles.CustomBanner}>
        <Text className={wizardStyles.A11YText}>
          {`Your protocol should help you to define details that might impact the outcomes of your review.
            Remove any that are not relevant to your review.`}
        </Text>
      </Banner>
    </>
  );
};

const CharacteristicStudyFormDescription = () => {
  return (
    <Stack spacing={4}>
      <Text className={wizardStyles.A11YText}>
        {`1. A table will be created with a row for each detail and a column for each group reported in the study.`}
      </Text>
      <Text className={wizardStyles.A11YText}>
        {`2. Collecting this data will allow you to compare the differences between interventions.`}
      </Text>
    </Stack>
  );
};

export const interventionsWizardData = ({
  hasExtractedData = false,
}: {
  hasExtractedData?: boolean;
}) => {
  const data = {
    1: {
      left: {
        heading: '1. Add interventions',
        description: <InterventionsDescription />,
        fields: (
          <InterventionsFields hasExtractedData={hasExtractedData} fullWidth />
        ),
      },
      right: {
        description: <InterventionsStudyFormDescription />,
        image: InterventionsImage,
      },
    },
    2: {
      left: {
        heading: ' 2. Add your relevant intervention details',
        description: <CharacteristicDescription />,
        fields: (
          <CharacteristicsFields
            hasExtractedData={hasExtractedData}
            fullWidth
          />
        ),
      },
      right: {
        description: <CharacteristicStudyFormDescription />,
        image: CharacteristicsImage,
      },
    },
  };
  return data as WizardMetaData;
};

export const interventionsPendoKeys = {
  skip: 'interventions-wizard-skip',
  next: 'interventions-wizard-next',
  back: 'interventions-wizard-back',
  done: 'interventions-wizard-done',
  setupNow: 'interventions-wizard-setup-now',
  editSetup: 'interventions-wizard-edit-setup',
} as WizardPendoData;
